import React from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import HomeIcon from "@mui/icons-material/Home";
import { B8VALIDATION } from "../../../Validation";

// import { Academic } from '../../../Pages/Validation';

// import { Activetiesvalidation } from '../Validation';
import FormControl from "@mui/material/FormControl";
import { Box } from "react-bootstrap-icons";
import ComponentLoader from "../../../../ComponentLoader";

function B8Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const [Studentbtn, setStudentbtn] = useState([]);

  const [depatId, setDepatId] = useState("");
  const [organization, setOrganization] = useState("");
  const [fPOlinkageType, setFPOlinkageType] = useState("");
  const [purpose, setPurpose] = useState("");
  const [loader,setLoader] =useState(true);
  const [depatIdErr, setDepatIdErr] = useState("");
  const [organizationErr, setOrganizationErr] = useState("");
  const [fPOlinkageTypeErr, setFPOlinkageTypeErr] = useState("");
  const [purposeErr, setPurposeErr] = useState("");

  const [dropdown, setDropdown] = useState([]);
  const [FPOLinkType, setFPOLinkType] = useState([]);
  const [token, setToken] = useState("");
  const [id, setId] = useState(0);
  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [invis, setInvestigator] = useState();

  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(B8VALIDATION),
  });

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
      handleDropdown(tok);
      handleLovType(tok);
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head("Academic");
  }, []);
  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const investigator = localStorage.getItem("loginId");
    setInvestigator(investigator);
  }, []);

  const handleBack = () => {
    navigate("/B8");
  };

  const edit = (item) => {
    console.log(item);
    setDepatId(item.depatId);
    setOrganization(item.organization);
    setFPOlinkageType(item.fpOlinkageType);
    setPurpose(item.purpose);
    setId(item.id);
  };

  const handleClickOpen = () => {
    setOpen(true);
    //  navigate("/Activities")
  };

  const handleClose = () => {
    setOpen(false);
    // setId(0)
  };

  // DeptId Dropdown //
  const handleDropdown = async (token) => {
    console.log(token);
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const { data } = await axios.get(`${window.BASE}${window.DeptId}`, {
        headers: h,
      });
      console.log(data);
      if (data) {
        setDropdown(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Lov Type //
  const handleLovType = async (token, LinkagesType) => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const { data } = await axios.get(
        `${window.BASE}${window.LOVTYPE}${"LinkagesType"}`,
        {
          headers: h,
        }
      );
      console.log(data);
      if (data) {
        setFPOLinkType(data);setLoader(false);
      }
    } catch (error) {
      console.log(error);setLoader(false);
    }
  };

  const handleLeavepage = async (data) => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    console.log(token);
    const d = {
      id,
      DepatId: parseInt(depatId),
      Organization: organization,
      FPOlinkageType: fPOlinkageType,
      Purpose: purpose,
      MRSId: state.id,
      investigatorId: parseInt(invis),
      rptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(`${window.BASE}${window.B8SAVE}`, d, {
          headers: h,
        });
        console.log(data);
        setStudentbtn(data);
        if (data.result === "Success") {
          alert("Successfully Submitted");
          navigate("/B8");
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          // toastError(data.errorMsgs)
        }
        //   setDirect(data);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(`${window.BASE}${window.B8EDIT}`, d, {
          headers: h,
        });
        console.log(data);

        if (data.result === "Success") {
          alert("Successfully Submitted");
          navigate("/B8");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const formValidateFun=()=>{
    if(!depatId){
      setDepatIdErr(true)
      document.getElementById("depatId").focus()
    }else if(!organization){
      setOrganizationErr(true)
      document.getElementById("organization").focus()
    }else if(!fPOlinkageType){
      setFPOlinkageTypeErr(true)
      document.getElementById("fPOlinkageType").focus()
    }else if(!purpose){
      setPurposeErr(true)
      document.getElementById("purpose").focus()
    }else{
      handleLeavepage()
    }
  }

  return (
    <div className="main-container-margin">
       <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/monthyReport">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>Academic Linkages (B8)</span>
        </div>
      </div>
      <div className="from-mains">
        <div className="form-control">
          <h5 style={{ margin: 20 }}>
            B8.Academic / Industrial / FPO linkages established:
          </h5>

          <FormControl style={{ width: "48%", margin: 12 }} error={depatIdErr} id="depatId">
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Institute Name
            </InputLabel>
            <Select
              variant="outlined"
              style={{ height: "44px" }}
              value={depatId}
              onChange={(e) => {
                setDepatId(e.target.value)
                setDepatIdErr(false)
              }}
            >
              {dropdown?.map((option, index) => {
                return (
                  <MenuItem key={index} value={option.id}>
                    {option.instituteName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <TextField
            error={organizationErr}
            id="organization"
            label="Name of the linked organization (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={organization}
            onChange={(e) => {
              setOrganization(e.target.value);
              setOrganizationErr(false);
            }}
          />

          <FormControl style={{ width: "48%", margin: 12 }} error={fPOlinkageTypeErr} id="fPOlinkageType">
            <InputLabel id="demo-simple-select-helper-label" size="small">
            FPO Linkage
            </InputLabel>
            <Select
              variant="outlined"
              style={{ height: "45px" }}
              value={fPOlinkageType}
              onChange={(e) => {
                setFPOlinkageType(e.target.value)
                setFPOlinkageTypeErr(false)
              }}
            >
              {FPOLinkType?.map((option, index) => {
                return (
                  <MenuItem key={index} value={option.lovName}>
                    {option.lovName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <TextField
            error={purposeErr}
            id="purpose"
            label="Purpose (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={purpose}
            onChange={(e) => {
              setPurpose(e.target.value);
              setPurposeErr(false);
            }}
          />

          <div className="from-last">
            <button
              type="submit"
              className="deactivate-buttons"
              style={{paddingTop:"5px"}}
              onClick={handleBack}
            >
              Back
            </button>
            <button type="submit" className="sbmit-buttons" style={{paddingTop:"5px"}} onClick={formValidateFun}>
            Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default B8Inside;
